import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Form, Input, Button, message } from 'antd';
import { useAuth } from '../../../hooks/useAuth';
import { createProjectGroup } from '../../../services/project';

const { TextArea } = Input;

const CreateProjectGroup: React.FC = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values: { name: string; remarks: string }) => {
    try {
      setLoading(true);
      const response = await createProjectGroup({
        name: values.name,
        remarks: values.remarks || undefined,
      });
      message.success('项目组创建成功');
      navigate('/dashboard/customer/project-groups/list');
    } catch (error: any) {
      console.error('创建项目组失败:', error);
      if (error.response) {
        console.error('错误响应:', error.response.data);
        message.error(error.response.data.detail || error.response.data.message || '创建项目组失败');
      } else {
        message.error(error.message || '创建项目组失败');
      }
    } finally {
      setLoading(false);
    }
  };

  // 检查用户权限（允许：客户、管理员；禁止：员工）
  React.useEffect(() => {
    if (user && !(user.role === 'customer' || user.role === 'admin')) {
      message.error('只有客户或管理员可以创建项目组');
      navigate('/dashboard');
    }
  }, [user, navigate]);


  if (!user || !(user.role === 'customer' || user.role === 'admin')) {
    return null;
  }

  return (
    <Card title="创建项目组" className="max-w-2xl mx-auto">
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        initialValues={{ remarks: '' }}
      >
        <Form.Item
          name="name"
          label="项目组名称"
          rules={[
            { required: true, message: '请输入项目组名称' },
            { max: 100, message: '项目组名称不能超过100个字符' },
          ]}
        >
          <Input placeholder="请输入项目组名称" />
        </Form.Item>

        <Form.Item
          name="remarks"
          label="备注信息"
          rules={[{ max: 500, message: '备注信息不能超过500个字符' }]}
        >
          <TextArea
            placeholder="请输入备注信息（选填）"
            rows={4}
            showCount
            maxLength={500}
          />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading} block>
            创建项目组
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default CreateProjectGroup; 